import './scss/main.scss';
import './js/sticky-hover'
import './js/book-now-scroll'
import playIntroAnimation from './js/intro-animation'
import './js/mobile-menu-opening'

import { forEach, getParameterByName, hasClass, isMobile } from './js/utilities'
import SlideShow from './js/SlideShow'
import initPhotoSwipeFromDOM from './js/gallery'

const ANIMATION_COOKIE_ID = 'playedIntro';
const hasToPlayVideo = document.cookie.indexOf(ANIMATION_COOKIE_ID) === -1 || (getParameterByName('playIntro') && getParameterByName('playIntro').toLowerCase() === 'true');

let video;

// video

const isHome = hasClass( document.body, 'home' );
if( isHome && !isMobile() ){
  // replace slideshow on top with video
  const slideshow = document.body.querySelector('.slideshow');
  if( slideshow ){
    video = document.createElement('video');
    video.setAttribute('loop','loop');
    const addSource = (src, type) => {
      var source = document.createElement( 'source' );
      source.src = src;
      source.type = type;
      video.appendChild( source );
    };
    addSource( '/video/masberenguer-intro.mp4', 'video/mp4' );
    addSource( '/video/masberenguer-intro.ogg', 'video/ogg' );
    addSource( '/video/masberenguer-intro.webm', 'video/webm' );
    slideshow.insertAdjacentElement('afterEnd', video);
    document.body.removeChild( slideshow );
    if( !hasToPlayVideo ){
      video.play();
    }
  }
}

// slideshow

const slideshows = [];

forEach( document.querySelectorAll( '.slideshow' ), (el) => {
  slideshows.push( new SlideShow( el ) );
});

// intro



if( hasToPlayVideo )
{
  playIntroAnimation( () => {
    forEach( slideshows, (s) => {
      s.checkVisibility();
    });
    if( video ){
      video.play();
    }
  });
}

// gallery

initPhotoSwipeFromDOM('.gallery');

// language

document.cookie = "language=" + document.documentElement.lang + '; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/